import { Cancelled, CancelledOrder, ECommerce, NewOrder, Processing, RecentOrdersTitle, Shipped, ShippedOrder } from "../../../../Constants/Constants";
import { Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import CommonOrders from "./OrderHistoryData/CommonOrders";
import DataTableOrderHistory from "./OrderHistoryData/DataTableOrderHistory";

const OrderHistoryContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={RecentOrdersTitle} parent={ECommerce} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <CommonOrders title={NewOrder} btn={Processing} color={"primary"} />
            <CommonOrders title={ShippedOrder} btn={Shipped} color={"success"} />
            <CommonOrders title={CancelledOrder} btn={Cancelled} color={"danger"} />
          </Col>
            <DataTableOrderHistory />
        </Row>
      </Container>
    </>
  );
};

export default OrderHistoryContainer;
